module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/contest_stats/nba/survive/2_points&assists-fb17d9959414be8f8f3c2f3b20f0b9be.svg";